module.exports = __webpack_public_path__ + "media/tempsFinalitzat2.1476ea8c.mp3";